export default __webpack_public_path__ + "static/user2-c2c44f545f4d1460e44439bea6c1e26d.jpeg";